// extracted by mini-css-extract-plugin
module.exports = {"Error":"Error_Error__5gLCT","Error--OccupySpace":"Error_Error--OccupySpace__XboW8"};